module.exports = __webpack_public_path__ + "img/filter.edb19cc1.svg";